export const CONSTRUCTION_TYPES = {
  '1401': { desc: 'Rudimentario provisional', vu: 950 },
  '1402': { desc: 'Industrial económico', vu: 1700 },
  '1403': { desc: 'Industrial económico mediano', vu: 2340 },
  '1404': { desc: 'Industrial mediano', vu: 2980 },
  '1405': { desc: 'Industrial mediano calidad', vu: 3520 },
  '1406': { desc: 'Industrial calidad', vu: 4150 },
  '1407': { desc: 'Industrial calidad lujo', vu: 4780 },
  '1408': { desc: 'Industrial lujo', vu: 5410 },
  '1409': { desc: 'Antiguo típico', vu: 2650 },
  '1410': { desc: 'Antiguo típico común', vu: 3080 },
  '1411': { desc: 'Antiguo común', vu: 3490 },
  '1412': { desc: 'Antiguo común notable', vu: 3960 },
  '1413': { desc: 'Antiguo notable', vu: 4530 },
  '1414': { desc: 'Antiguo notable relevante', vu: 5120 },
  '1415': { desc: 'Antiguo relevante', vu: 5840 },
  '1416': { desc: 'Moderno económico', vu: 4210 },
  '1417': { desc: 'Moderno económico mediano', vu: 5360 },
  '1418': { desc: 'Moderno mediano', vu: 7620 },
  '1419': { desc: 'Moderno mediano calidad', vu: 9870 },
  '1420': { desc: 'Moderno calidad', vu: 12140 },
  '1421': { desc: 'Moderno calidad lujo', vu: 14680 },
  '1422': { desc: 'Moderno lujo', vu: 17520 },
  '1423': { desc: 'Alberca', vu: 6890 },
  '1424': { desc: 'Cancha deportiva', vu: 2270 }
};

export const CONSERVATION_STATES = {
  1: { desc: 'Muy bueno / nuevo', factor: 1.00 },
  2: { desc: 'Bueno',             factor: 0.90 },
  3: { desc: 'Regular',           factor: 0.80 },
  4: { desc: 'Malo',              factor: 0.65 },
  5: { desc: 'Ruinoso',           factor: 0.50 }
};

export const LAND_USES = [
  'Habitacional',
  'Habitacional / Comercial',
  'Comercial y de servicios',
  'Industrial',
  'Agropecuario',
  'Equipamiento urbano',
  'Mixto'
];

export const DOCUMENT_TYPES = [
  'Escritura Pública',
  'Título de propiedad',
  'Contrato privado',
  'Sentencia judicial',
  'Folio Real'
];

export const NOTARIES = [
  { n: '4',  nom: 'Lic. Mario Luna Yáñez',            lugar: 'San Juan del Río' },
  { n: '12', nom: 'Lic. Roberto Cabrera Valencia',    lugar: 'Querétaro' },
  { n: '25', nom: 'Lic. Alejandra Muñoz de la Peña',  lugar: 'Querétaro' },
  { n: '7',  nom: 'Lic. Fernando Olvera Rangel',      lugar: 'Querétaro' },
  { n: '33', nom: 'Lic. Ma. Guadalupe Ríos Serrano',  lugar: 'El Marqués' },
  { n: '18', nom: 'Lic. Jorge Alberto Sandoval Trejo', lugar: 'Corregidora' }
];

export const LAND_VALUE_STREETS = [
  'JOSE MA. MORELOS',
  'CORREGIDORA',
  'LUIS PASTEUR',
  '5 DE FEBRERO',
  'BERNARDO QUINTANA',
  'ZARAGOZA',
  'UNIVERSIDAD',
  'TECNOLÓGICO'
];

export const QUERY_STEPS = [
  'Estableciendo conexión con el WS de Catastro',
  'Autenticando credenciales del organismo',
  'Validando estructura de la clave catastral',
  'Consultando el padrón catastral municipal',
  'Recuperando valuación y registro de construcciones',
  'Cargando geometría georreferenciada'
];